/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useLocation, useNavigate } from "react-router-dom";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { bankingService } from "../../services/bankingService";
import DelgroProgressBar from "../../generals/DelgroProgressBar";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { GetFundTransferAtom, SetFundTransferAtom } from "../../store/fundTransferAtom";

const TRANSFER_TYPE_NAMES = {
    19: "Transfer To Another Account",
    20: "Receive From Another Account",
};

const fundTransferColumns = [
    {
        title: 'Acc Ref',
        key: 'account_ref_no',
        dataIndex: 'account_ref_no',
        sorter: (a, b) => (a?.account_ref_no ?? 0) - (b?.account_ref_no ?? 0),
    },
    {
        title: 'Date',
        key: 'journal_date',
        dataIndex: 'journal_date',
        sorter: (a, b) => (a?.journal_date ?? '').localeCompare(b?.journal_date ?? ''),
        render: (journal_date) => <span>{formatCustomDate(journal_date)}</span>,
    },
    {
        title: 'Transfer From',
        key: 'transfer_from_head',
        dataIndex: 'transfer_from_head',
        sorter: (a, b) => (a?.transfer_from_head ?? '').localeCompare(b?.transfer_from_head ?? ''),
    },
    {
        title: 'Transfer To',
        key: 'transfer_to_head',
        dataIndex: 'transfer_to_head',
        sorter: (a, b) => (a?.transfer_to_head ?? '').localeCompare(b?.transfer_to_head ?? ''),
    },

    {
        title: 'Amount',
        key: 'amount',
        dataIndex: 'amount',
        sorter: (a, b) => (a?.amount ?? 0) - (b?.amount ?? 0),
        render: (amount) => <span>{formatCustomNumber(amount)}</span>,
    },
    {
        title: 'Created By',
        key: 'created_by',
        dataIndex: 'created_by',
        sorter: (a, b) => (a?.created_by ?? '').localeCompare(b?.created_by ?? ''),
    },
    {
        title: 'Created Date',
        key: 'created_date',
        dataIndex: 'created_date',
        sorter: (a, b) => (a?.created_date ?? '').localeCompare(b?.created_date ?? ''),
        render: (created_date) => <span>{formatCustomDate(created_date)}</span>,
    },
];


function FundTransferMainPage() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];

    const setFundTransferAtom = SetFundTransferAtom();
    const getFundTransferAtom = GetFundTransferAtom();


    useEffect(() => {
        document.title = 'Fund Transfer';
        if (getFundTransferAtom?.fund_transfer?.length) {
            return;
        }
        getFundTransferListFromApi();
    }, []);


    useEffect(() => {
        if (sessionStorage.getItem("reloadPage") === "true") {
            sessionStorage.removeItem("reloadPage");
            getFundTransferListFromApi();
        }
    }, []);


    const getFundTransferListFromApi = async () => {
        bankingService.fundTransferList().then(response => {
            const serverData = response?.data;
            setFundTransferAtom({
                fund_transfer: serverData?.fund_transfer?.length ? serverData.fund_transfer : [],
                trans_rec_chart_of_accounts: serverData?.trans_rec_chart_of_accounts?.length ? serverData.trans_rec_chart_of_accounts : [],
            });
        });
    }


    function addNewInvoice() {
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
    }


    function OnItemCellClick(fund) {
        console.log('fund ', fund);
        const id = fund['account_ref_no'];
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`)
    }


    return (
        <>
            <section>
                <section className="bg-white  px-2    md:flex justify-between ">
                    <div className="flex px-2 mt-1">
                        <Tooltip title="Reload">
                            <RestartAlt className="cursor ml-2 mt-1" onClick={() => getFundTransferListFromApi()} color="primary" fontSize="large" />
                        </Tooltip>
                    </div>


                    <div className="flex justify-between">
                        <button className="  font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8 text-sm">IMPORT</button>
                        <div className="btn-group">
                            <button
                                className=" font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8   text-sm"
                                data-toggle="dropdown"
                                aria-expanded="false"
                            >
                                EXPORT
                            </button>
                        </div>

                        <button
                            onClick={addNewInvoice}
                            className="bg-buttonColor font-[Poppins] py-3 mt-1 mr-1 px-3 rounded md:ml-8  text-white text-xs"
                        >
                            ADD NEW
                        </button>
                    </div>
                </section>

                <section className="mt-5">
                    {!getFundTransferAtom.fund_transfer?.length && <DelgroProgressBar />}

                    <GeneralCustomTable
                        tableHeadList={fundTransferColumns}
                        tableDataList={getFundTransferAtom.fund_transfer}
                        rowKey={record => record.account_ref_no}
                        handleRowClick={OnItemCellClick}
                    />
                </section>
            </section>
        </>
    );
}

export default FundTransferMainPage;
